import { Component, h } from 'preact';
import linkState from 'linkstate';

import { FileUploadFormControl } from '../../common/file-upload-form-control.component';
import { FormattedNumberInput } from '../../common/formatted-number-input.component';
import { HopplerModalizer } from '../../common/hoppler-modalizer.component';
import { ReqState } from '../../../../../types';
import { InquiryDocument } from '../../../../../types/inquiries';
import { route } from 'preact-router';
import { InqStageTransitionContent } from './inq-stage-transition-content.component';
import { DatePickerControl } from '../../common/date-picker-control.component';

interface InqUploadContractModalProps {
  contractsReqState: ReqState;
  contractChoices: InquiryDocument[];
  submitState: ReqState;

  onClose: () => void;
  onSubmit: (contractKey: string, date: string, files: FileList, amount: number) => void;
}

interface InqUploadContractModalState {
  contractKey?: string;
  date?: string;
  files?: FileList;
  amountForCollection?: number;
}

export class InqUploadContractModal extends Component<InqUploadContractModalProps, InqUploadContractModalState> {
  onSubmit(event: Event) {
    event.preventDefault();
    const { contractKey, date, files, amountForCollection } = this.state;

    this.props.onSubmit(contractKey, date, files, amountForCollection);
  }

  isSubmitButtonEnabled() {
    const state = this.state;
    return !!(
      state.contractKey &&
      state.files && state.files.length > 0
      // state.amountForCollection
    )
  }

  onProceed() {
    route('/kumita-brokers/inquiries/for-collection?actionFrom=upload-contract');
    this.props.onClose();
  }

  getContractListSelect(props: InqUploadContractModalProps, state: InqUploadContractModalState) {
    if (props.contractsReqState === ReqState.SUCCESS) {
      if (props.contractChoices.length > 0) {
        return (
          <select className="form-control" value={ state.contractKey }>
            { props.contractChoices.map(contract => (
              <option value={ contract.contractKey }>{ contract.documentName }</option>
            ))}
          </select>
        );
      } else {
        return (
          <p className="mb-0">
            <strong className="text-danger d-block mb-2">This inquiry has no existing contracts.</strong>
            Please create a contract before uploading a contract file.
          </p>
        );
      }
    } else if (props.contractsReqState === ReqState.IN_PROGRESS) {
      return (
        <input type="text" className="form-control" disabled placeholder="Loading contracts for this inquiry..." />
      );
    }
  }

  getSubmitButton(props: InqUploadContractModalProps, state: InqUploadContractModalState) {
    let text = 'Upload';

    if (props.submitState === ReqState.IN_PROGRESS) {
      return (
        <button type="submit" className="btn btn-secondary" disabled>
          <i className="fas fa-cog fa-spin" /> Uploading...
        </button>
      );
    } else {
      return (
        <button type="submit" className="btn btn-secondary" disabled={ !this.isSubmitButtonEnabled() }>
          Upload
        </button>
      );
    }
  }

  getForm(props: InqUploadContractModalProps, state: InqUploadContractModalState) {
    const hasContracts = props.contractChoices && props.contractChoices.length > 0;

    return (
      <form className="hi-inqupconmod__content" onSubmit={ event => this.onSubmit(event) }>
        <div className="hi-input-group">
          <label className="hi-input-group__label">Select Contract</label>
          { this.getContractListSelect(props, state) }
        </div>

        <div className="hi-input-group">
          <label className="hi-input-group__label">Date Signed</label>
          <DatePickerControl className="form-control" value={ state.date }
            onChange={ linkState(this, 'date') }
            disabled={ !hasContracts } />
        </div>

        <div className="hi-input-group">
          <label className="hi-input-group__label">Upload File</label>
          <FileUploadFormControl selectedFiles={ state.files }
            onChange={ linkState(this, 'files', 'target.files') }
            accept='image/*'
            disabled={ !hasContracts } />
        </div>

        <div className="hi-input-group">
          <label className="hi-input-group__label">Total Contract Amount</label>
          <FormattedNumberInput className="form-control" placeholder="PHP"
            value={ state.amountForCollection }
            prefix='PHP '
            onChange={ linkState(this, 'amountForCollection', 'target.value') }
            disabled={ !hasContracts } />
        </div>

        { this.getSubmitButton(props, state) }
      </form>
    )
  }

  getSuccessContent(props: InqUploadContractModalProps) {
    return (
      <div className="d-flex flex-fill justify-content-center align-items-center">
        <InqStageTransitionContent targetName='For Collection'
          onClose={ props.onClose }
          onProceed={ () => this.onProceed() } />
      </div>
    )
  }

  render(props: InqUploadContractModalProps, state: InqUploadContractModalState) {
    return (
      <HopplerModalizer onClose={ () => null }>
        <div className="hi-inqupconmod">
          <div className="hi-inqupconmod__title-bar">
            <span className="hi-inqupconmod__title-label">Upload Contract</span>
            <button className="btn btn-link hi-inqupconmod__title-close" onClick={ props.onClose }>
              <i className="fas fa-times" /> Close
            </button>
          </div>

          <div className="hi-inqupconmod__body">
            { props.submitState !== ReqState.SUCCESS ? this.getForm(props, state) : this.getSuccessContent(props) }
          </div>
        </div>
      </HopplerModalizer>
    );
  }
  
  componentWillReceiveProps(nextProps: InqUploadContractModalProps) {
    if (nextProps.contractChoices && !this.props.contractChoices && nextProps.contractChoices.length > 0) {
      const latestContract = nextProps.contractChoices[nextProps.contractChoices.length - 1];
      this.setState({ contractKey: latestContract.contractKey });
    }
  }
}